<script setup>

import { ref } from 'vue'


let ShowMenu = ref(false);

</script>

<template>

  <header class="w-full h-auto">

    <section class="container mx-auto w-full h-[70px] bg-white flex justify-between items-center box-border p-1 shadow shadow-dark-50">

      <section class="w-4/12 md:w-2/12 h-full flex flex-col justify-around items-start md:items-center">
        <img src="./../assets/logo.webp" class="w-full h-1/2 object-contain" alt="">
        <a href="mailto:info@rayagroupco.com">info@rayagroupco.com</a>
      </section>

      <section class="w-5/12 h-full hidden md:flex justify-around items-center">
        <button class="h-full  hover:text-sky-600" @click="$emit('change_component','home')">Home</button>
        <button class="h-full  hover:text-sky-600" @click="$emit('change_component','services')">Services</button>
        <button class="h-full  hover:text-sky-600" @click="$emit('change_component','products')">Products</button>
        <button class="h-full  hover:text-sky-600" @click="$emit('change_component','contactus')">Contact us</button>
      </section>

      <section class="w-3/12 h-full hidden md:flex justify-center items-center">
        <img src="./../assets/search.svg" class="w-[25px] h-[25px] object-contain mr-1" alt="">
        <input type="text" class="w-7/12 h-[30px] outline-none rounded-md border-2 border-sky-500 text-center text-[12px] text-sky-500 placeholder-sky-500" placeholder="Search...">
      </section>


      <section class="w-2/12 h-full flex  md:hidden justify-end items-center">
        <button @click="ShowMenu = !ShowMenu" class="w-[30px] h-[30px] flex justify-center items-center">
          <img src="./../assets/menu.webp" :class="{'flex' : ShowMenu == false , 'hidden' : ShowMenu == true}" class="w-full h-full object-contain" alt="">
          <img src="./../assets/close.webp" :class="{'hidden' : ShowMenu == false , 'flex' : ShowMenu == true}" class="w-full h-full object-contain" alt="">
        </button>
      </section>


    </section>

  </header>


  <section :class="{'hidden' : ShowMenu == false , 'flex' : ShowMenu == true}" class="container mx-auto w-full h-auto  md:hidden flex-col justify-around items-center">

    <section class="w-11/12 h-[50px] flex justify-center items-center">
        <img src="./../assets/search.svg" class="w-[25px] h-[25px] object-contain mr-1" alt="">
        <input type="text" class="w-7/12 h-[30px] outline-none rounded-md border-2 border-sky-500 text-center text-[12px] text-sky-500 placeholder-sky-500" placeholder="Search...">
      </section>

      <section dir="rtl" class="w-11/12 h-[100px]  grid grid-rows-3 grid-cols-2 items-center gap-2">
        <button class="h-full col-span-1   hover:text-sky-600" @click="$emit('change_component','home')">Home</button>
        <button class="h-full col-span-1   hover:text-sky-600" @click="$emit('change_component','services')">Services</button>
        <button class="h-full col-span-1   hover:text-sky-600" @click="$emit('change_component','products')">Products</button>
        <button class="h-full col-span-1   hover:text-sky-600" @click="$emit('change_component','contactus')">Contactus</button>
      </section>

     

  </section>

</template>

<style scoped></style>
